<template>
  <div class="container sv036">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お問い合わせ</HeadingOne>

    <p>
      お申し込みに関するご質問や、ご契約内容の変更、暗証番号などをお忘れの場合はお電話にて受け付けいたします。
    </p>

    <section>
      <HeadingTwo>お問い合わせの前に</HeadingTwo>
      <p>
        お客さまからお問い合わせの多いご質問をご案内しております。お問い合わせの前にぜひご参照ください。
      </p>
      <p class="_mb-md-60">
        ※ご利用限度額の増枠をご希望の場合は<a
          href="https://qa.kddi-fs.com/faq/show/4323?category_id=295&site_domain=loan"
          class="-underline"
          >こちら</a
        >
      </p>

      <CardBox class="-faq _mb-md-120 _mb-sm-60">
        <CardHeader>お問い合わせの多いご質問</CardHeader>
        <CardBody>
          <ListGroup>
            <ListItem
              class="-link"
              href="https://qa.kddi-fs.com/category/show/304?site_domain=loan"
              target="_blank"
              >新規お申し込みに関するご質問</ListItem
            >
            <ListItem
              class="-link"
              href="https://qa.kddi-fs.com/category/show/305?site_domain=loan"
              target="_blank"
              >お借り入れに関するご質問</ListItem
            >
            <ListItem
              class="-link"
              href="https://qa.kddi-fs.com/category/show/306?site_domain=loan"
              target="_blank"
              >ご返済に関するご質問</ListItem
            >
            <ListItem
              class="-link"
              href="https://qa.kddi-fs.com/category/show/307?site_domain=loan"
              target="_blank"
              >その他のよくあるご質問</ListItem
            >
          </ListGroup>
          <BtngroupSingle>
            <BtnMain
              class="-normal"
              href="https://qa.kddi-fs.com/?site_domain=loan"
              target="_blank"
              >よくあるご質問トップへ</BtnMain
            >
          </BtngroupSingle>
        </CardBody>
      </CardBox>

      <HeadingTwo id="section_01" name="section_01">お問い合わせ先</HeadingTwo>
      <p>
        以下にお電話でお問い合わせください。<br />「秘密のことばを忘れた」「氏名を変更した」などのお問い合わせもこちらで受付しております。
      </p>

      <CardBox class="_mb-md-120 _mb-sm-60">
        <CardHeader>
          <BtnToggle collapse-target="au-wallet-loan" class="-plus">
            <h3 class="heading">au PAY スマートローン 会員さま専用デスク</h3>
          </BtnToggle>
        </CardHeader>
        <CollapseItem id="au-wallet-loan" :visible="true">
          <CardBody>
            <HeadingIcon class="-primary -bold _mb-0">
              <IconBox src="menu-contact" class="icon -md"></IconBox>
              <p class="txt01">
                <a href="tel:0570-003-858" class="-line"
                  ><span class="txt02">0570-003-858</span></a
                ><br class="-pcnone" />（通話料有料）
              </p>
            </HeadingIcon>
            <small
              >※一部のIP電話からはご利用いただけない場合がございます。繋がらない場合は下記の番号へお問い合わせください。</small
            >
            <HeadingIcon class="-primary -bold _mt-20">
              <IconBox src="menu-contact" class="icon -md"></IconBox>
              <p class="txt01">
                <a href="tel:023-695-3858" class="-line"
                  ><span class="txt02">023-695-3858</span></a
                ><br class="-pcnone" />（通話料有料）
              </p>
            </HeadingIcon>
            <p>受付時間：9:00～18:00（年中無休）</p>
            <ListGroup class="-note">
              <ListItem class="-note"
                >受付時間外は「よくあるご質問」をあわせてご利用ください。</ListItem
              >
              <ListItem class="-note txt03"
                >番号のおかけ間違いにご注意ください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CollapseItem>
      </CardBox>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CardBox from "@/components/card/CardBox";
import BtnToggle from "@/components/button/BtnToggle";
import CollapseItem from "@/components/collapse/CollapseItem";
import IconBox from "@/components/icons/IconBox";
import HeadingIcon from "@/components/heading/HeadingIcon";

export default {
  name: "Sv036",
  components: {
    BreadcrumbGroup,
    HeadingIcon,
    IconBox,
    CollapseItem,
    BtnToggle,
    CardBox,
    CardBody,
    CardHeader,
    ListItem,
    ListGroup,
    BtnMain,
    BtngroupSingle,
    HeadingTwo,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "お問い合わせ",
      description:
        "au PAY スマートローンに関するお問い合わせ先はこちらになります。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,お問い合わせ",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お問い合わせ",
          active: true,
        },
      ],
    };
  },
  mounted() {
    if (this.$route.hash.match(/^#/)) {
      let id = this.$route.hash.replace(/^#/, "");
      let element = document.getElementById(id);
      this.$scrollTo(element, 500, { easing: "ease" });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.notice-box {
  display: flex;
  justify-content: space-between;
  text-align: left !important;
  .txt-box {
    .heading {
      font-size: 24px;
      line-height: 28px;
      color: $orange;
      font-weight: bold;
    }
  }
}

.card-box {
  #au-wallet-loan {
    > .card-body {
      > .heading-icon {
        justify-content: start;
        align-items: end;
        > .txt01 {
          color: $black;
          font-weight: normal;
          @include mq-down(md) {
            text-align: left;
          }
          > .-line {
            @include mq-down(md) {
              border-bottom: 1px solid $black;
            }
            > .txt02 {
              font-size: 32px;
              line-height: 28px;
              font-weight: bold;
              font-size: 24px;
              line-height: 24px;
              @include mq-up(md) {
                font-size: 32px;
                line-height: 28px;
              }
            }
          }
        }
      }
      .txt03 {
        color: $danger;
      }
    }
  }
}

#section_01 {
  margin-top: -100px;
  padding-top: 100px;
  @include mq-up(md) {
    margin-top: -160px;
    padding-top: 160px;
  }
}
</style>
